// Lookbook API — mirrors /app/mobile/src/lib/lookbook-api.ts
import { apiFetch, BACKEND_URL } from './api';

export { BACKEND_URL };

// ---------- Host endpoints ----------
export const getLookbook = (eventId) =>
  apiFetch(`/api/v1/events/${eventId}/lookbook`);

export const patchLookbook = (eventId, body) =>
  apiFetch(`/api/v1/events/${eventId}/lookbook`, { method: 'PATCH', body: JSON.stringify(body) });

export const createSection = (eventId, title) =>
  apiFetch(`/api/v1/events/${eventId}/lookbook/sections`, { method: 'POST', body: JSON.stringify({ title }) });

export const patchSection = (eventId, sectionId, body) =>
  apiFetch(`/api/v1/events/${eventId}/lookbook/sections/${sectionId}`, { method: 'PATCH', body: JSON.stringify(body) });

export const deleteSection = (eventId, sectionId) =>
  apiFetch(`/api/v1/events/${eventId}/lookbook/sections/${sectionId}`, { method: 'DELETE' });

export const addItemToSection = (eventId, sectionId, submissionId) =>
  apiFetch(`/api/v1/events/${eventId}/lookbook/sections/${sectionId}/items`, { method: 'POST', body: JSON.stringify({ submission_id: submissionId }) });

export const removeItemFromSection = (eventId, sectionId, submissionId) =>
  apiFetch(`/api/v1/events/${eventId}/lookbook/sections/${sectionId}/items/${submissionId}`, { method: 'DELETE' });

export const reorderSectionItems = (eventId, sectionId, itemIds) =>
  apiFetch(`/api/v1/events/${eventId}/lookbook/sections/${sectionId}/reorder`, { method: 'POST', body: JSON.stringify({ item_ids: itemIds }) });

export const publishLookbook = (eventId, body) =>
  apiFetch(`/api/v1/events/${eventId}/lookbook/publish`, { method: 'POST', body: JSON.stringify(body) });

export const republishLookbook = (eventId, body) =>
  apiFetch(`/api/v1/events/${eventId}/lookbook/republish`, { method: 'POST', body: JSON.stringify(body) });

export const pauseLookbook = (eventId) =>
  apiFetch(`/api/v1/events/${eventId}/lookbook/pause`, { method: 'POST' });

export const resumeLookbook = (eventId) =>
  apiFetch(`/api/v1/events/${eventId}/lookbook/resume`, { method: 'POST' });

export const unpublishLookbook = (eventId) =>
  apiFetch(`/api/v1/events/${eventId}/lookbook/unpublish`, { method: 'POST' });

export const rotateShareToken = (eventId) =>
  apiFetch(`/api/v1/events/${eventId}/lookbook/rotate-share-token`, { method: 'POST' });

export const patchLookbookSettings = (eventId, body) =>
  apiFetch(`/api/v1/events/${eventId}/lookbook/settings`, { method: 'PATCH', body: JSON.stringify(body) });

export const previewLookbook = (eventId) =>
  apiFetch(`/api/v1/events/${eventId}/lookbook/preview`);

export const refreshLookbookWatermark = (eventId) =>
  apiFetch(`/api/v1/events/${eventId}/lookbook/refresh-watermark`, { method: 'POST' });

// ---------- Viewer endpoints ----------
export const resolveLookbook = (body, useAuth = false) =>
  apiFetch('/api/v1/lookbook/resolve', { method: 'POST', body: JSON.stringify(body), auth: useAuth });

export const refetchManifest = (viewerToken) =>
  apiFetch(`/api/v1/lookbook/manifest?viewer_token=${encodeURIComponent(viewerToken)}`, { auth: false });

export function derivativeThumbnailUrl(subId, viewerToken) {
  return `${BACKEND_URL}/api/v1/lookbook/derivative/${subId}/thumbnail?viewer_token=${encodeURIComponent(viewerToken)}`;
}

export function derivativeFullUrl(subId, viewerToken) {
  return `${BACKEND_URL}/api/v1/lookbook/derivative/${subId}/full?viewer_token=${encodeURIComponent(viewerToken)}`;
}
